<template>
  <div>
    <b-modal id="modal_process_background" hide-footer size="xl">
      <template #modal-title>
        Procesos agendados
      </template>

      <b-collapse visible>



        <!-- Actualizar listado -->
        <div class="d-flex justify-content-end mb-3">
          <b-button variant="outline-primary" @click="_loadProccessBackground">
            <i class="fa fa-refresh mr-1"></i>
            Actualizar procesos agendados
          </b-button>
        </div>

        <!-- historico -->
        <b-table responsive striped hover :items="backgroundProcess" :fields="columns" bordered thead-class="table-active"
          show-empty empty-text="No hay resultados para mostrar.">



          <!-- estado -->
          <template v-slot:cell(estado_procesamiento)="data">
            <b-badge v-if="data.item.estado_procesamiento == 'PROCESANDO'" variant="warning"
              v-text="data.item.estado_procesamiento" />
            <b-badge v-else-if="data.item.estado_procesamiento == 'TERMINADO'" variant="success"
              v-text="data.item.estado_procesamiento" />
            <b-badge v-else variant="secondary"  v-text="data.item.estado_procesamiento ? data.item.estado_procesamiento : 'PENDIENTE'" />
          </template>


          <template v-slot:cell(total)="data">
            <p class="text-right m-0"> {{ data.item.json.total_products ? data.item.json.total_products : 0}}</p>
          </template>

          <template v-slot:cell(year_import)="data">
            <p class="text-right m-0"><i class="text-muted">{{ data.item.json.year_import ? data.item.json.year_import : `No aplica`}}</i></p>
          </template>

          <template v-slot:cell(errores)="data">
            {{
              data.item.errores ? data.item.errores :
                  !data.item.estado_procesamiento || data.item.estado_procesamiento == 'PROCESANDO'
                      ? ''
                      : 'Sin errores'
            }}
          </template>


        </b-table>


      </b-collapse>

      <br />
      <div class="d-flex justify-content-end align-items-center mt-4">
        <b-button @click="closeModal">
          <i class="fa fa-close fa-lg"></i>
          <span class="ml-1"> Cerrar</span>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import Swal from 'sweetalert2';
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "ModalShowProcessBackground",
  data() {
    return {
      columns: [
        { key: 'created_at', label: 'Fecha de solicitud', sortable: true },
        { key: 'updated_at', label: 'Fecha de generación', sortable: true },
        { key: 'total', label: 'Total productos importados', sortable: true },
        { key: 'year_import', label: 'Año de importación', sortable: true },
        { key: 'errores', label: 'Errores del proceso', sortable: true },
        {
          key: "estado_procesamiento",
          label: "Estado de generación",
          sortable: true,
        },
      ],
    }
  },
  computed: {
    ...mapState("decret_1630", ['backgroundProcess']),
    ...mapState('productos', ['filtro']),
  },
  methods: {
    ...mapActions("decret_1630", ['loadProccessBackground']),
    closeModal() {
      this.$bvModal.hide('modal_process_background');
    },
    async _loadProccessBackground() {
      await this.loadProccessBackground({company_id: this.filtro.empresa, type: 'INVENTARIO-PRODUCTOS-DECRETO-1630'});
    },
  },
}

</script>
